import React, { useState } from 'react';
import { Button, IconButton, TextField, Card, CardContent, Grid, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Delete, Edit, Add } from '@mui/icons-material';
import BurgerFormGroup from './BurgerFormGroup'; 
import '../../../../styles/BurgerManager.scss';

const BurgerManager = ({ sectionId, burgersSections, setBurgersSections, handleEditItem }) => {
  const [newSubsection, setNewSubsection] = useState({ name: '', burgers: [] });
  const [editingSubsectionIndex, setEditingSubsectionIndex] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [subsectionToDeleteIndex, setSubsectionToDeleteIndex] = useState(null);

  const handleEditSubsection = (index) => {
    setEditingSubsectionIndex(index);
    setNewSubsection(burgersSections[index]);
    handleEditItem(burgersSections[index]);
  };

  const handleOpenConfirmDelete = (index) => {
    setSubsectionToDeleteIndex(index);
    setConfirmDeleteOpen(true);
  };

  const handleConfirmDeleteClose = () => {
    setSubsectionToDeleteIndex(null);
    setConfirmDeleteOpen(false);
  };

  const handleDeleteSubsection = () => {
    const item = burgersSections.find((_, i) => i === subsectionToDeleteIndex);
    const updatedSubsections = burgersSections.filter((_, i) => i !== subsectionToDeleteIndex);
    setBurgersSections(updatedSubsections, true, item.id);
    handleConfirmDeleteClose();
  };

  return (
    <div>
      <h2>Gestione Sezioni</h2>
      <Grid container spacing={3} style={{ marginTop: '20px' }}>
        {burgersSections.map((subsection, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card>
              <CardContent>
                <div className='burgerry-header'>
                  <h3>{subsection.name}</h3>
                  <div className='burgerry-header'>
                    <IconButton onClick={() => handleEditSubsection(index)}>
                      <Edit />
                    </IconButton>
                    <IconButton onClick={() => handleOpenConfirmDelete(index)}>
                      <Delete />
                    </IconButton>
                  </div>
                </div>
                <BurgerFormGroup
                  subsection={subsection}
                  burgers={subsection.burgers}
                  setBurgers={(updatedBurgers) => {
                    const updatedSubsections = burgersSections.map((c, i) =>
                      i === index ? { ...c, burgers: updatedBurgers } : c
                    );
                    const item = updatedSubsections.find((c, i) => i === index);
                    setBurgersSections(updatedSubsections, false, null, item);
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={confirmDeleteOpen} onClose={handleConfirmDeleteClose}>
        <DialogTitle>Conferma Eliminazione</DialogTitle>
        <DialogContent>
          <Typography>Sei sicuro di voler eliminare questa sezione?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteSubsection} color="error" variant="contained">
            Elimina
          </Button>
          <Button onClick={handleConfirmDeleteClose} className="cancel-btn" color="secondary">Annulla</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BurgerManager;
